import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a 2 m wide sectional garage door in a concrete frame: a white
// door face with horizontal panel grooves (thin darker strips) and a row of
// small square windows in the top section. Spans two tiles along X at the
// standard 2.6 m wall height.
const CONCRETE = "#9a9a94";
const DOOR = "#e8e4dc";
const GROOVE = "#c6c1b7";
const GLASS = "#9fc4d4";

export const garageDoor = defineModel({
  id: "garage-door",
  batchId: "modern",
  name: "Garage door",
  tags: ["modern", "outdoor", "structure", "wall", "door", "garage"],
  summary: "A 2 m wide sectional garage door in a concrete frame.",
  description:
    "A two-tile garage front of the Modern Living kit: a white sectional " +
    "door face with horizontal panel grooves and small square windows in the " +
    "top row, set in a concrete frame with piers at both sides and a header " +
    "beam. Runs along X like every wall piece, 2.6 m tall overall.",
  tiles: { w: 2, h: 1 },
  footprint: 1.8,
  parts(): Part[] {
    const grooves: Part[] = [];
    // three panel grooves splitting the door face into four sections
    for (let i = 0; i < 3; i++) {
      grooves.push({
        geometry: new THREE.BoxGeometry(1.7, 0.03, 0.11),
        color: GROOVE,
        position: [0, 0.55 + i * 0.5, 0],
      });
    }
    const windows: Part[] = [];
    // small square windows in the top door section
    for (let i = 0; i < 3; i++) {
      windows.push({
        geometry: new THREE.BoxGeometry(0.28, 0.22, 0.12),
        color: GLASS,
        position: [-0.5 + i * 0.5, 1.85, 0],
      });
    }
    return [
      // concrete piers at both sides
      { geometry: new THREE.BoxGeometry(0.15, 2.6, 0.15), color: CONCRETE, position: [-0.925, 1.3, 0] },
      { geometry: new THREE.BoxGeometry(0.15, 2.6, 0.15), color: CONCRETE, position: [0.925, 1.3, 0] },
      // concrete header beam over the opening (2.15 -> 2.6)
      { geometry: new THREE.BoxGeometry(1.7, 0.45, 0.15), color: CONCRETE, position: [0, 2.375, 0] },
      // white sectional door face (0.05 -> 2.15)
      { geometry: new THREE.BoxGeometry(1.7, 2.1, 0.1), color: DOOR, position: [0, 1.1, 0] },
      ...grooves,
      ...windows,
    ];
  },
  animations: [],
});
